module.exports = __webpack_public_path__ + "img/Logo_showzam_512.6f7e7629.png";